// extracted by mini-css-extract-plugin
export default {"bread_crumbs":"BreadCrumb_bread_crumbs__3xNzH"};